import React from "react";
import type { Components } from "react-markdown";

/**
 * Renderer overrides shared by every chat view that renders assistant markdown.
 *
 * `table` is wrapped so a table too wide for the message column scrolls
 * horizontally instead of overflowing it. See `.markdown-table-wrapper` in
 * styles/PlanChat.css.
 */
export const markdownComponents: Components = {
    a: ({ href, children }) => (
        <a href={href} target="_blank" rel="noopener noreferrer">
            {children}
        </a>
    ),
    table: ({ children }) => (
        <div className="markdown-table-wrapper">
            <table>{children}</table>
        </div>
    ),
};

export default markdownComponents;
